import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true); // Abierto por defecto

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* Header fijo */}
      <Header onMenuToggle={handleSidebarToggle} />
      
      {/* Contenido principal con sidebar */}
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        {/* Sidebar */}
        <Sidebar open={sidebarOpen} onClose={handleSidebarClose} />
        
        {/* Área de contenido principal */}
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
          {/* Área de contenido principal */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              overflow: 'auto',
              p: 2,
              width: '100%',
              mx: 'auto',
            }}
          >
            <Container maxWidth={false} disableGutters sx={{ py: 1 }}>
              {children}
            </Container>
          </Box>
          
          {/* Footer */}
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
